// 创建订单
export async function postHttpCreateOrder(url, data, merchantNo, secretKey) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Basic ${btoa(merchantNo + ':' + secretKey)}`
    },
    body: JSON.stringify(data)
  }).then((response) => response.json())
}
